import { directionUrl } from 'apps/bayada/constants';
import { officeDetailsProps } from './office-page';
import { OfficeModel } from 'apps/bayada/app/find-an-office/office-data-parser';

/**
 * Opens the default maps app to provide directions from the origin to the specified destination.
 * @param {string} origin - The origin address or coordinates.
 * @param {string} lat - The latitude of the destination.
 * @param {string} lng - The longitude of the destination.
 */
export const goToDirections = (origin: string, lat: string, lng: string) => {
  const directionsUrl = directionUrl
    ?.replace('{origin}', origin)
    ?.replace('{destinationLat}', lat)
    ?.replace('{destinationLng}', lng);
  if (window) {
    window?.open(directionsUrl);
  }
};

/**
 * Handles the action to get directions to a specific office location.
 * @param {Object} office - The office location details.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const handleDirections = (office?: any) => {
  const destination = {
    lat: office?.mailingAddressLatitude,
    lng: office?.mailingAddressLongitude
  };
  const origin = '';
  goToDirections(origin, destination?.lat, destination?.lng);
};

export const toTitleCase = (str: string) => {
  return str.toLowerCase().replace(/(?:^|\s)\w/g, (match) => {
    return match.toUpperCase();
  });
};

export const getOfficePhone = (
  officeDetails: officeDetailsProps | null | undefined,
  officeData: OfficeModel | null | undefined
): string | undefined => {
  // Early return if no office data
  if (!officeData) return undefined;

  // Check for updated phone in office details
  if (officeDetails?.offices?.length) {
    const correctOffice = officeDetails.offices.find(
      (item) => String(item?.office) === String(officeData.officeId)
    );
    if (correctOffice && correctOffice?.updatedPhone) {
      return correctOffice?.updatedPhone;
    }
  }
  return officeData?.phone;
};
